import { render, staticRenderFns } from "./UserMngtDtl.vue?vue&type=template&id=2cfd2b84"
import script from "./UserMngtDtl.vue?vue&type=script&lang=js"
export * from "./UserMngtDtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports